import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormField from '../FormField';

export default function HabitacaoPlanejamento() {
  const { watch } = useFormContext();
  
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre habitação e planejamento urbano do município, incluindo déficit habitacional e instrumentos de planejamento.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          name="deficit_habitacional"
          label="Déficit habitacional"
          type="numeric"
          thousandSeparator="."
          decimalSeparator=","
          placeholder="Digite o déficit habitacional"
          helpText="Número de unidades habitacionais necessárias para suprir a demanda"
        />
        
        <FormField
          name="habitacao_social"
          label="Estoque de habitação social"
          type="numeric"
          thousandSeparator="."
          decimalSeparator=","
          placeholder="Digite o estoque de habitação social"
          helpText="Número de unidades habitacionais de interesse social existentes"
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="plano_diretor_ano"
          label="Ano da última atualização do Plano Diretor Municipal"
          type="number"
          placeholder="Digite o ano"
          helpText="Ano da última atualização ou revisão do Plano Diretor"
          validation={{
            min: {
              value: 1990,
              message: 'O ano deve ser posterior a 1990',
            },
            max: {
              value: new Date().getFullYear(),
              message: `O ano deve ser anterior ou igual a ${new Date().getFullYear()}`,
            },
          }}
        />
        
        <FormField
          name="zoneamento_existencia"
          label="Existência de zoneamento industrial e comercial"
          type="radio"
          options={[
            { value: 'sim', label: 'Sim' },
            { value: 'nao', label: 'Não' },
          ]}
          helpText="Indique se o município possui zoneamento específico para áreas industriais e comerciais"
        />
      </div>
      
      <div className="mt-4">
        <FormField
          name="drenagem_urbana"
          label="Sistemas de drenagem urbana"
          placeholder="Descreva os sistemas de drenagem urbana"
          helpText="Principais características dos sistemas de drenagem urbana existentes"
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="areas_verdes"
          label="Áreas verdes (% do território)"
          type="percent"
          placeholder="Digite a porcentagem"
          helpText="Porcentagem do território municipal ocupado por áreas verdes"
          validation={{
            min: {
              value: 0,
              message: 'O valor deve ser maior ou igual a 0',
            },
            max: {
              value: 100,
              message: 'O valor deve ser menor ou igual a 100',
            },
          }}
        />
        
        <FormField
          name="espaco_publico"
          label="Espaço público por habitante (m²/hab)"
          type="numeric"
          thousandSeparator="."
          decimalSeparator=","
          suffix=" m²/hab"
          placeholder="Digite o valor em m²/hab"
          helpText="Área de espaço público disponível por habitante"
        />
      </div>
      
      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao7"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
        
        <FormField
          name="links_acesso_secao7"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
